function ReportDetails() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Report.Details visual. <br/>
   /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// *** v1.0.2 - 09.01.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - ESLint changes                                                    *<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 06.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added support for more buttons                                   *<br />
    /// * - documentation                                   *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
   
}
ReportDetails.prototype = new window.vcTemplate();
ReportDetails.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.wiz = $("#vc-wizard-report-gen").vcWizard({ stepWidth: 268, errorText: me.resources.wizardError });
        me.initClickHandler();
        me.visual.find(".vc-wizard-step:first").trigger("click");
        if ((me.ids.repConfigErrors & me.errConstants.Exports) === me.errConstants.Exports) {
            me.wiz.vcWizard("setInvalid", 1);
        }
        if ((me.ids.repConfigErrors & me.errConstants.File) === me.errConstants.File) {
            me.wiz.vcWizard("setInvalid", 3);
        }
        if ((me.ids.repConfigErrors & me.errConstants.Sheets) === me.errConstants.Sheets) {
            me.wiz.vcWizard("setInvalid", 5);
        }
        if ((me.ids.repConfigErrors & me.errConstants.Projects) === me.errConstants.Projects) {

            me.wiz.vcWizard("setInvalid", 2);
       
        }

        if (me.newProject) {
            for (var i = 0; i <= 5; i++) {
                me.wiz.vcWizard("setInvalid", i);
            }
        }
        return true;
    } catch (ex) {
        me.writeError('ReportDetails.init', ex);
        return false;
    }

};

ReportDetails.prototype.loadDetailForms = function () {

    var me = this;
    var type;
    try {
        if (me.error) { return false; }
        //init list entry click handler
        type = me.visual.find('.vc-wizard-step.active').attr("data-projectdetail");
        
            me.vcVisual.setShowFullscreen(false);
            me.vcVisual.setShowHeaderMenu(false);
            me.visual.find("#detailContent").html(me.vcC.getLoadingIcon());
        me.visual.find("#project-settings-name, #user-assign").html("");

            switch (type) {

                case "report":
                    me.vcVisual.addVisualContentByName('d', 'VISUAL_FORM_REPORT_GENERAL', 'etailContent', window.getCurrentTimestamp(), me.visual.height(), me.width, "true," + me.ids.rrid, "", me.deviceType);
                    break;

            case "report_signals":
                    me.vcVisual.addVisualContentByName('de', 'WIDGET_REPORT_SIGNAL_META_ASSIGNMENT', 'tailContent', window.getCurrentTimestamp(), me.visual.height(), me.width, '', JSON.stringify({ "rrid": me.ids.rrid }), me.deviceType);
                break;
            case "report_template_create":
                    me.vcVisual.addVisualContentByName('det', 'WIDGET_REPORT_TEMPLATE_GENERATION', 'ailContent', window.getCurrentTimestamp(), me.visual.height(), me.width, '', JSON.stringify({ "rrid": me.ids.rrid }), me.deviceType);
                break;
            case "logger":
                var width = 930;
                if ($(".report-manager-details").width() < 1400) {
                    width = 800;
                }
                me.vcVisual.addVisualBaseByName('deta','WIDGET_ASSIGNMENT_REPORT_LOGGER','ilContent',window.getCurrentTimestamp(),me.visual.height() - 80,width,JSON.stringify({ "id": me.ids.rrid, "assID": me.ids.rrid }),JSON.stringify({ "id": me.ids.rrid, "assID": me.ids.rrid }),me.deviceType);
                    break;
           case "report_specific_signals":

                    var width = 930;
                    if ($(".report-manager-details").width() < 1400) {
                        width = 800;
                    }
                    $("#detailContent").ReportSettings({ invokeType: "addVisualContent", parameter: { rid: me.ids.rrid } });

                    //me.vcVisual.addVisualBaseByName('deta', 'WIDGET_ASSIGNMENT_REPORT_SIGNAL', 'ilContent', window.getCurrentTimestamp(), me.visual.height() - 80, width, JSON.stringify({ "id": me.ids.rrid, "assID": me.ids.rrid }), JSON.stringify({ "id": me.ids.rrid, "assID": me.ids.rrid }), me.deviceType);
                    break;
            case "creators2template":
                me.vcVisual.addVisualBaseByName('detai','WIDGET_ASSIGNMENT_REPORT_CREATORS','lContent',window.getCurrentTimestamp(),me.visual.height(), me.width,JSON.stringify({ "id": me.ids.rrid, "AssID": me.ids.rrid }),"",me.deviceType);

                break;
                case "sheets":
                    
                me.vcVisual.addVisualContentByName('detail', 'WIDGET_REPORT_SHEET_MANAGEMENT', 'Content', window.getCurrentTimestamp(), me.visual.height() - 80,  me.width, JSON.stringify({ "retID": me.ids.rrid }), "", me.deviceType);
                break;

            default:
                me.visual.find("#detailContent").html("");
                break;
            }
        

        return true;

    } catch (ex) { me.writeError("ReportDetails.loadDetailForms", ex); return false; }
};

ReportDetails.prototype.doEvent = function (event) {
    /// <summary>
    /// calls the button back function when a project got deleted
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        switch (event.msg) {
            case "MS_CLOSE_PROJECT":
                me.btnBack();
                break;
          
            case "REP_NEW":
                me.setNewReport(event.values.newReport);
                break;
            case "REP_CONFIG_VALID":
                if (event.values.rrid) {me.ids.rrid = event.values.rrid;}

              if (event.values.valid) {
                    me.wiz.vcWizard("setValid", event.values.step);
                } else {
                    me.wiz.vcWizard("setInvalid", event.values.step);
                }
                break;

        }
        return true;
    } catch (ex) { me.writeError("ReportDetails.doEvent", ex); return false; }
};
ReportDetails.prototype.setNewReport = function(newReport) {
    var me = this;
    try {
        me.visual.find("#divBtnLoggerReport").button({ "disabled": newReport });
        me.visual.find("#divBtnUserToLogger").button({ "disabled": newReport });
        me.visual.find("#divBtnCreatorToTemplate").button({ "disabled": newReport });


    } catch (ex) {
        me.writeError("ReportDetails.setNewReport", ex);
    }
};
ReportDetails.prototype.btnBack = function () {
    /// <summary>
    /// Handles the click of the back button <br/>
    /// by calling the webservice and calling the overview list again, needs to be 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.hide();
        window._VCMQ.produce(me.visual, me.vcgid, 'REP_DET_BACK', {});
        return true;
    } catch (ex) {
        me.writeError('ReportDetails.btnBack', ex);
        return false;
    }
};
ReportDetails.prototype.initClickHandler = function () {
    var me = this;
    try {
        if (me.error) { return false; }
     
        me.visual.find('#divBtnBackToReportOverview').button().off("click").on("click", function () {
            me.btnBack();
        });
        me.visual.find(".vc-wizard-step").off("click").on("click", function () {

            me.wiz.vcWizard("setActive", $(this).attr("data-step") - 1);
            me.loadDetailForms();
            
        });
        return true;
    } catch (ex) {
        me.writeError('ReportDetails.initClickHandler', ex);
        return false;
    }
};

ReportDetails.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.toggle-button, #divContent').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};